

export const fakeId = (id: number | undefined) => {
    if(id === undefined){
        return 0;
    }
    return id * 17 + 1000;
}